import { apiRequest } from '@/shared/api/client';
import type { MeResponse } from '@/shared/api/types';

export async function fetchMe(): Promise<MeResponse> {
  return apiRequest<MeResponse>('/v1/me', { method: 'GET' });
}
